import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Table from "atoms/Table";
import { getBillingEntityList } from "redux/selectors";

// Shows tax fraction as a percentage: 0.16 -> "16%", 0.2 -> "20%"
const formatTax = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const num = Number(String(value).replace("%", "").trim());
  return Number.isNaN(num) ? String(value) : `${+(num * 100).toFixed(2)}%`;
};

const columns = [
  { title: "Billing Entity", dataIndex: "name", key: "name" },
  { title: "Tax", dataIndex: "tax", key: "tax", render: formatTax },
];

function BillingEntityList() {
  const history = useHistory();
  const billingEntityList = useSelector(getBillingEntityList);

  const dataSource = (billingEntityList || []).map((entity) => ({
    key: entity.id,
    entityId: entity.id,
    name: entity.name,
    tax: entity.tax,
  }));

  return (
    <>
      <div className="d-flex justify-content-between">
        <b className="mb-3" style={{ fontSize: "20px" }}>
          Finance Settings
        </b>
      </div>
      <div className="styled-card" style={{ marginTop: "10px" }}>
        <Table
          columns={columns}
          dataSource={dataSource}
          rowKey="entityId"
          onRow={(record) => ({
            onClick: () =>
              history.push(`/finance-settings-details/${record.entityId}`),
            style: { cursor: "pointer" },
          })}
          pagination={{ pageSize: 20 }}
        />
      </div>
    </>
  );
}

export default BillingEntityList;